import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';

import { BaseReportService, ConfigServerService, CustomHttp } from '../../../../core';

@Injectable({
    providedIn: 'root'
})
export class PedidoReportService {
    private pathApi: string;
    private pathApiPrint: string;


    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp,
                private baseReportService: BaseReportService) {
        this.pathApi = `${configServerService.getPathApi()}/pedido`;
        this.pathApiPrint = `${configServerService.getPathApiPrint()}/pedido`;
    }

    /** Realiza a impressão do pedido informado */
    print(id: number) {
        this.customHttp.get<Blob>(`${this.pathApi}/${id}/print`, { responseType: 'blob' })
            .subscribe(
                pdf => {
                    this.baseReportService.open(pdf);
                },
                error => {
                    this.baseReportService.openError(error);
                }
            )
    }

    /** Realiza a impressão do resultado líquido do pedido informado */
    printResultadoLiquido(id: number) {
        this.customHttp.get<Blob>(`${this.pathApi}/${id}/print/resultadoliquido`, { responseType: 'blob' })
            .subscribe(
                pdf => {
                    this.baseReportService.open(pdf);
                },
                error => {
                    this.baseReportService.openError(error);
                }
            )
    }

    /** Realiza a impressão do romaneio do pedido informado */
    printRomaneio(ids: number[]): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            // Params
            let params = new HttpParams();
            // Pedidos
            if (ids) {
                ids.forEach(id => {
                    params = params.append('id', id.toString());
                });
            }

            this.customHttp.get<Blob>(`${this.pathApiPrint}/romaneio`, {params, responseType: 'blob'})
                .subscribe(
                    pdf => {
                        this.baseReportService.open(pdf, true);
                        resolve();
                    },
                    error => {
                        this.baseReportService.openError(error);
                        reject(error);
                    }
                );
        });
    }

    /** Realiza a impressão das etiquetas para a expedição dos pedidos */
    printExpedicaoEtiquetas(ids: number[]): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            // Params
            let params = new HttpParams();
            // Pedidos
            if (ids) {
                ids.forEach(id => {
                    params = params.append('id', id.toString());
                });
            }

            this.customHttp.get<Blob>(`${this.pathApiPrint}/expedicao/etiquetas`, {params, responseType: 'blob'})
                .subscribe(
                    pdf => {
                        this.baseReportService.open(pdf, true);
                        resolve();
                    },
                    error => {
                        this.baseReportService.openError(error);
                        reject(error);
                    }
                );
        });
    }
}
